"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Authenticated", {
  enumerable: true,
  get: function get() {
    return _Authenticated.default;
  }
});
Object.defineProperty(exports, "AuthProvider", {
  enumerable: true,
  get: function get() {
    return _AuthProvider.default;
  }
});
Object.defineProperty(exports, "LegacyAuthProvider", {
  enumerable: true,
  get: function get() {
    return _LegacyAuthProvider.default;
  }
});
Object.defineProperty(exports, "Callback", {
  enumerable: true,
  get: function get() {
    return _Callback.default;
  }
});
Object.defineProperty(exports, "Gatekeeper", {
  enumerable: true,
  get: function get() {
    return _Gatekeeper.default;
  }
});
Object.defineProperty(exports, "Logout", {
  enumerable: true,
  get: function get() {
    return _Logout.default;
  }
});
Object.defineProperty(exports, "IdleTimer", {
  enumerable: true,
  get: function get() {
    return _IdleTimer.default;
  }
});
Object.defineProperty(exports, "AuthContext", {
  enumerable: true,
  get: function get() {
    return _AuthContext.default;
  }
});
exports.default = exports.createMiddleware = exports.useAuthManager = exports.useIsUserGranted = exports.isGranted = exports.authRouting = exports.authRouteConstants = exports.removeAuthItem = exports.setAuthItem = exports.getAuthItem = exports.AuthManagers = exports.AuthReducer = exports.AuthActions = void 0;
var _Authenticated = _interopRequireDefault(require("./components/Authenticated"));
var _AuthProvider = _interopRequireDefault(require("./components/AuthProvider"));
var _LegacyAuthProvider = _interopRequireDefault(require("./components/LegacyAuthProvider"));
var _Callback = _interopRequireDefault(require("./components/Callback"));
var _Gatekeeper = _interopRequireDefault(require("./components/Gatekeeper"));
var _Logout = _interopRequireDefault(require("./components/Logout"));
var _Actions = _interopRequireWildcard(require("./actions"));
var _reducer = _interopRequireDefault(require("./reducer"));
var _authManagers = _interopRequireDefault(require("./authManagers"));
var _getAuthItem2 = _interopRequireDefault(require("./utils/getAuthItem"));
var _setAuthItem2 = _interopRequireDefault(require("./utils/setAuthItem"));
var _isGranted2 = _interopRequireDefault(require("./utils/isGranted"));
var _removeAuthItem2 = _interopRequireDefault(require("./utils/removeAuthItem"));
var _routes = _interopRequireDefault(require("./routes"));
var _routing = _interopRequireDefault(require("./routing"));
var _useIsUserGranted2 = _interopRequireDefault(require("./hooks/useIsUserGranted"));
var _useAuthManager2 = _interopRequireDefault(require("./hooks/useAuthManager"));
var _createMiddleware2 = _interopRequireDefault(require("./lib/redux/createMiddleware"));
var _IdleTimer = _interopRequireDefault(require("./components/IdleTimer"));
var _AuthContext = _interopRequireDefault(require("./context/AuthContext"));

/* @TODO deprecate AuthRouteConstants in the 5.xx release, remove in 6.x.x */
// components
// context
var AuthActions = _Actions;
exports.AuthActions = AuthActions;
var AuthReducer = _reducer.default;
exports.AuthReducer = AuthReducer;
var AuthManagers = _authManagers.default;
exports.AuthManagers = AuthManagers;
var getAuthItem = _getAuthItem2.default;
exports.getAuthItem = getAuthItem;
var setAuthItem = _setAuthItem2.default;
exports.setAuthItem = setAuthItem;
var removeAuthItem = _removeAuthItem2.default;
exports.removeAuthItem = removeAuthItem;
var authRouteConstants = _routes.default;
exports.authRouteConstants = authRouteConstants;
var authRouting = _routing.default;
exports.authRouting = authRouting;
var isGranted = _isGranted2.default;
exports.isGranted = isGranted;
var useIsUserGranted = _useIsUserGranted2.default;
exports.useIsUserGranted = useIsUserGranted;
var useAuthManager = _useAuthManager2.default;
exports.useAuthManager = useAuthManager;
var createMiddleware = _createMiddleware2.default;
exports.createMiddleware = createMiddleware;
var _default = {
  // components
  Authenticated: _Authenticated.default,
  AuthProvider: _AuthProvider.default,
  LegacyAuthProvider: _LegacyAuthProvider.default,
  Callback: _Callback.default,
  Gatekeeper: _Gatekeeper.default,
  Logout: _Logout.default,
  AuthActions: AuthActions,
  AuthReducer: AuthReducer,
  AuthManagers: AuthManagers,
  getAuthItem: getAuthItem,
  setAuthItem: setAuthItem,
  removeAuthItem: removeAuthItem,
  authRouteConstants: authRouteConstants,
  authRouting: authRouting,
  isGranted: isGranted,
  // hooks
  useIsUserGranted: useIsUserGranted,
  useAuthManager: useAuthManager,
  // redux
  createMiddleware: createMiddleware
};
exports.default = _default;